import { useState } from "react";
import BackButton from "../../../../components/Button/BackButton";
import FormInput from "../../../../components/Form/FormInput";
import TextEditor from "../../../../components/Form/TextEditor";
import { FIELD_LABEL } from "../../../../components/Form/formFieldStyles";
import { btn } from "../../../../components/Button/buttonStyles";

const isUrl = (value) => {
  try {
    return ["http:", "https:"].includes(new URL(value).protocol);
  } catch {
    return false;
  }
};

const isBlank = (html) => !html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

const VendorAgreementForm = ({ agreement, onSave, onCancel }) => {
  const [form, setForm] = useState({ url: agreement.url || "", text: agreement.text || "" });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleTextChange = (text) => {
    setForm((prev) => ({ ...prev, text }));
    setErrors((prev) => ({ ...prev, text: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const found = {};
    const url = form.url.trim();
    if (url && !isUrl(url)) found.url = "Enter a valid URL starting with http:// or https://";
    if (isBlank(form.text)) found.text = "Vendor agreement text is required.";
    setErrors(found);
    if (Object.keys(found).length) return;

    setSaving(true);
    const ok = await onSave({ url: url || null, text: form.text });
    setSaving(false);
    if (ok) onCancel();
  };

  return (
    <div>
      <div className="mb-5 flex items-center gap-3">
        <BackButton onClick={onCancel} />
        <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">
          Update Vendor Agreement
        </h1>
      </div>

      <form
        onSubmit={handleSubmit}
        noValidate
        className="rounded-lg border border-gray-100 bg-white shadow-sm"
      >
        <div className="space-y-4 p-5">
          <div className="md:w-1/2">
            <FormInput
              label="URL"
              name="url"
              type="url"
              value={form.url}
              onChange={handleChange}
              error={errors.url}
              placeholder="https://"
            />
          </div>

          <div>
            <label className={FIELD_LABEL}>
              Vendor Agreement Text <span className="text-danger-500">*</span>
            </label>
            <TextEditor value={form.text} onChange={handleTextChange} error={errors.text} />
          </div>
        </div>

        <div className="sticky bottom-0 flex gap-2 rounded-b-lg border-t border-gray-100 bg-white px-5 py-3 text-sm">
          <button type="submit" disabled={saving} className={btn("primary", "sm")}>
            {saving ? "Updating..." : "Update"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            className={btn("secondary", "sm")}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default VendorAgreementForm;